import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
// Components
import {Formik, Field, Form, ErrorMessage} from 'formik';
import Input from '../../../common/form-elements/input/input';
import FormErrorMessage from '../../../common/form-elements/form-error-message/form-error-message';
import UserService from '../../../../services/user-service';
// Helpers
import {
  schemaValidate,
  required,
  minLength,
  maxLength,
} from '../../../../helpers/validation-helpers';
import {addColorOptions} from '../../../../helpers/util';

const customStyles = {
  multiValue: (styles, {data}) => {
    return {
      ...styles,
      backgroundColor: data.color,
      color: 'white',
      padding: '4px 0 4px 10px',
      borderRadius: '8px',
    };
  },
  multiValueLabel: () => ({
    color: 'white',
    fontSize: '12px',
    lineHeight: '15px',
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    ':hover': {
      backgroundColor: 'inherit !important',
    },
  }),
};

class UserActivityForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      organizationsOptions: addColorOptions(UserService.getUserOrganizationsOptions()),
      rolesOptions: addColorOptions(this.props.rolesOptions),
    };
  }

  handleFormFieldChange = (field, props) => (value) => {
    props.setFieldValue(field, value);
  };

  render() {
    return (
      <Formik initialValues={this.props.initialValues} onSubmit={this.props.onFormSubmit}>
        {(props) => (
          <Form>
            <div className="glu-modal__body">
              <div className="glu-content__section">
                <div className="glu-form-row">
                  <div className="glu-label">Widget Title</div>
                  <Field
                    as={Input}
                    autoFocus
                    name="title"
                    className="glu-form-input-pad"
                    onChange={props.handleChange('title')}
                    validate={schemaValidate([required(), minLength(), maxLength(30)])}
                    invalid={props.errors.title && props.touched.title}
                  />
                  <ErrorMessage name="title" component={FormErrorMessage} />
                </div>
                <div className="glu-form-row">
                  <div className="glu-label">Number of items</div>
                  <Field
                    as={Select}
                    name="numberOfItems"
                    options={this.props.countOptions}
                    styles={customStyles}
                    isSearchable={false}
                    value={props.values.numberOfItems}
                    onChange={this.handleFormFieldChange('numberOfItems', props)}
                    className="glu-select glu-form-input-pad"
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="glu-form-row">
                  <div className="glu-label">Organizations</div>
                  <Field
                    as={Select}
                    name="organizations"
                    options={this.state.organizationsOptions}
                    styles={customStyles}
                    isSearchable
                    isMulti
                    value={props.values.organizations}
                    placeholder="All"
                    onChange={this.handleFormFieldChange('organizations', props)}
                    className="glu-select glu-form-input-pad"
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="glu-form-row">
                  <div className="glu-label">Roles</div>
                  <Field
                    as={Select}
                    name="roles"
                    options={this.state.rolesOptions}
                    styles={customStyles}
                    isSearchable
                    isMulti
                    value={props.values.roles}
                    placeholder="All"
                    onChange={this.handleFormFieldChange('roles', props)}
                    className="glu-select glu-form-input-pad"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
            </div>
            <footer className="glu-modal__footer">
              <div className="glu-flex-grow glu-flex-row">
                <div className="glu-flex-grow text-right">
                  <button
                    onClick={this.props.onCancel}
                    className="glu-btn glu-btn--secondary"
                    type="button"
                  >
                    Cancel
                  </button>
                </div>
                <div className="glu-flex-shrink">
                  <button type="submit" className="glu-btn glu-btn--primary">
                    Save
                  </button>
                </div>
              </div>
            </footer>
          </Form>
        )}
      </Formik>
    );
  }
}

UserActivityForm.propTypes = {
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
  countOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  onCancel: PropTypes.func.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  rolesOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default UserActivityForm;
